import 'cropperjs/dist/cropper.css';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cropper from 'react-cropper';

class CropImage extends Component {
  state = {
    imageFullUrl: null,
    minCroppedImageWidth: 510,
    minCroppedImageHeight: 510,
  };

  constructor(props) {
    super(props);

    this.updateStateImageData = this.updateStateImageData.bind(this);
    this.crop = this.crop.bind(this);
    this.cropmove = this.cropmove.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { filename, imageId } = this.props;
    if (!filename || !imageId) {
      return;
    }

    this.updateStateImageData(this.props);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { filename, imageId } = this.props;
    if (filename !== nextProps.filename
      && imageId !== nextProps.imageId) {
      this.updateStateImageData(nextProps);
    }
  }

  updateStateImageData(data) {
    const { toCropUrlBase } = this.props;
    const imageFullUrl = toCropUrlBase + data.filename;

    this.setState({ imageFullUrl });
  }

  crop() {
    const cropData = this.cropped.getData();
    const options = {
      custom_crop: {
        w: cropData.width,
        h: cropData.height,
        x: cropData.x,
        y: cropData.y,
      },
    };

    const {
      memberId,
      filename,
      imageId,
      saveCentered,
    } = this.props;

    const data = {
      member_id: memberId,
      filename,
      options,
      image_id: imageId,
    };

    saveCentered(data);
  }

  cropmove(e) {
    const data = this.cropped.getData();
    const {
      minCroppedImageWidth,
      minCroppedImageHeight,
    } = this.state;
    if ((data.width + 1) < minCroppedImageWidth) {
      e.preventDefault();
      data.width = minCroppedImageWidth;
      this.cropped.setData(data);
    }
    if ((data.height + 1) < minCroppedImageHeight) {
      e.preventDefault();
      data.height = minCroppedImageHeight;
      this.cropped.setData(data);
    }
  }

  render() {
    let cropSavingBtn = (
      <button
        type="button"
        onClick={this.crop}
        className="btn btn--b mtl admin-cropSubmit-btn"
      >
        Crop
      </button>
    );

    const { saving } = this.props;
    if (saving) {
      cropSavingBtn = (
        <button
          type="button"
          className="btn btn--b mtl admin-cropSubmit-btn"
          disabled
        >
          Saving ...
        </button>
      );
    }

    const { imageFullUrl } = this.state;
    const readyImage = (
      <div>
        <div className="dib admin-cropContainer">
          <Cropper
            ref={(img) => { this.cropped = img; }}
            src={imageFullUrl}
            aspectRatio={1 / 1}
            viewMode={1}
            autoCropArea={0.9}
            cropmove={this.cropmove}
            zoomable={false}
            preview="#preview"
          />
        </div>
        <div className="dib admin-cropPreview">
          <div id="preview" className="admin-cropPreview-image" />
          {cropSavingBtn}
        </div>
      </div>
    );

    return readyImage;
  }
}

CropImage.propTypes = {
  filename: PropTypes.string.isRequired,
  imageId: PropTypes.string.isRequired,
  memberId: PropTypes.string.isRequired,
  saveCentered: PropTypes.func.isRequired,
  toCropUrlBase: PropTypes.string.isRequired,
  saving: PropTypes.bool.isRequired,
};

export default CropImage;
